import notifier from './notifier';

export default function copyToClipboard(text: string, type: string) {
	const textArea = document.createElement('textarea');
	textArea.value = text;

	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		document.execCommand('copy');
		notifier.success('copied', type);
	} catch (err) {
		notifier.error('copying', type);
	}

	document.body.removeChild(textArea);
}
